import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  moreHref?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  moreHref,
  moreLabel = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-6 md:mb-8">
      <div className="min-w-0">
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-widest uppercase text-secondary-500 mb-2">
            <span className="w-4 h-0.5 bg-secondary-500 inline-block" />
            {eyebrow}
          </span>
        )}
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950">{title}</h2>
        {description && (
          <p className="mt-1.5 text-sm text-foreground-600 max-w-2xl">{description}</p>
        )}
      </div>
      {moreHref && (
        <Link
          to={moreHref}
          className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-line text-base" />
        </Link>
      )}
    </div>
  );
}